import cn from 'classnames';

import Image from '@framework/router/Next/Image';
import { Link } from '@framework/router/Next/Link';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import { ViewType } from '@/openMarket/application/Finsight/ProfilesContext/constants';
import { toSlug } from '@framework/url/helpers/toSlug';
import { IProfile } from '@/openMarket/domain/vo/IProfile';

import styles from './profileItem.module.scss';

interface IProps {
  profile: IProfile,
  viewType: ViewType,
  isMobile: boolean,
}

const ProfileItem = ({ profile, viewType, isMobile }: IProps) => {
  return (
    <div
      data-test="profileItem"
      className={ cn({
        [styles.profileGridType]: viewType === ViewType.GRID || isMobile,
        [styles.profileListType]: viewType === ViewType.LIST && !isMobile,
      }) }
    >
      <div className={ styles.logoWrapper }>
        <Image
          src={ profile.headerLogo.url }
          alt={ profile.name }
          title={ profile.name }
          height={ 30 }
          width={ 150 }
          className={ styles.logo }
          priority
        />
      </div>
      <div className={ styles.body }>
        <div>
          <h5 className={ styles.companyName } data-test="profileName">
            { profile.name }
          </h5>
          <p className={ styles.description } data-test="profileDescription">
            { profile.headerDescription }
          </p>
        </div>
        <Link to={ `/profile-${ profile.viewId }-${ toSlug(profile.name) }` }>
          <Button variant={ ButtonVariantType.action } className={ styles.button } dataTest="viewProfileButton">
            View Profile
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ProfileItem;
